import { EnumProdottoActions } from './prodotto_actions';
import update from 'immutability-helper';
import { DateFormatter } from 'arm-common';
import moment from 'moment';
import 'moment/locale/it';

const EnumActions = EnumProdottoActions;

const initialState = {

    listProdotto: [],
    detailsProdotto: {
        id: null,
        nome: null,
        descrizione: null,
        insertDate: null,
        insertUser: null,
        updateDate: null,
        updateUser: null,
        deleteDate: null,
        deleteUser: null,
        gruppiProdotto: [],
        prodottoPadre: {},
        prodottoCmp: {},
        documentiPolizze: [],
        valoreDefaultDurata: null,
        docTariffa: null,
        authAbilitazione: null,
        provvigioni: null,
        idOperatoreSegn: null
    },
    listaProdottoIntermediarioPojo: [],
    listCompagnie: [],
    listaPuntiVenditaOfCompagnia: [],
    provvigioniFilters: {},
    tabSelected: null,
    provvigioniPassiveFilters: {},
    psp: {
        dataValidita: new Date().getTime(),
    },

    listProdottiOrigine: [],
    prodottoOrigine: {},
    documentUpload: {},
    frazionamenti: [],
    pagamenti: [],
    operazioni: [],
    fondo: {},
    prodottoServiziEsterni: {},
    listFondiProdotto: [],
    linea: {},
    listAiPrintDocumenti: [],
    documentPrint: {},
    listaProdottiLineaLibera: [],
    durataA: [],
    listaSconto: [],
    listaSegnelatori: [],
    prodottoFirmaDigitale: {}
}



const prodotto = (state, action) => {
    if (typeof state === 'undefined') {
        return initialState
    }

    let moduleName = "[ProdottoReducer.js]"
    switch (action.type) {

        case EnumProdottoActions.PRODOTTO_INITIALIZED:
            return initialState
        case EnumProdottoActions.PRODOTTO_LIST:
            return Object.assign({}, state, { listProdotto: action.dati })

        case EnumProdottoActions.PRODOTTO_DETAILS:
            return Object.assign({}, state, { detailsProdotto: action.dati })

        case EnumProdottoActions.PRODOTTO_HANDLE_CHANGE:
            return update(state, {
                detailsProdotto: { $merge: action.dato }
            });
        case EnumProdottoActions.PRODOTTO_UPDATE:
            return update(state, action.prodotto);
        case EnumProdottoActions.COMPAGNIE_LIST:
            return Object.assign({}, state, { listCompagnie: action.dati })
        case EnumProdottoActions.PUNTO_VENDITA_LIST:
            return Object.assign({}, state, { listaPuntiVenditaOfCompagnia: action.dati })
        case EnumProdottoActions.PRODOTTO_CMP_HANDLE_CHANGE:
            return update(state, {
                detailsProdotto: {
                    prodottoCmpPojo: {
                        compagnia: {
                            $merge: action.dato
                        }
                    }
                }
            });
        case EnumProdottoActions.PRODOTTO_DETAILS:
            return Object.assign({}, state, { prodottoPadre: action.dati })
        case EnumProdottoActions.PRODOTTO_SERVIZI_ESTERNI:
            return update(state, {
                prodottoServiziEsterni: { $set: action.result }
            })
        case EnumProdottoActions.PRODOTTO_SERVIZI_ESTERNI_HANDLE_CHANGE:
            return update(state, {
                prodottoServiziEsterni: {
                    $merge: action.dato
                }
            })
        case EnumProdottoActions.FONDI_LIST_PRODOTTO:
            return Object.assign({}, state, { listFondiProdotto: action.dati })

        case EnumProdottoActions.LIST_PACCHETTO:
            return Object.assign({}, state, { listPacchetti: action.dati })

        case EnumProdottoActions.PACCHETTO_DETAILS:
            return Object.assign({}, state, { detailsPacchetto: action.dati })

        case EnumProdottoActions.LISTA_PRODOTTI_LINEA_LIBERA:
            return Object.assign({}, state, { listaProdottiLineaLibera: action.dati })

        case EnumProdottoActions.PRODOTTO_VALORE_DEFAULT_DURATA:
            return Object.assign({}, state, { valoreDefaultDurata: action.dati })

        case EnumProdottoActions.PRODOTTO_FIRMA_DIGITALE_HANDLE_CHANGE:
            return update(state, {
                prodottoFirmaDigitale: {
                    $merge: action.dato
                }
            })
        case EnumProdottoActions.SEGNELATORI_LOAD_LIST:
            return Object.assign({}, state, { listaSegnelatori: action.dati })

            case EnumProdottoActions.PRODOTTO_FIRMA_DIGITALE:
            return update(state, {
                prodottoFirmaDigitale: { $set: action.result }
            })
            //added for deleting garanzie  (Controllare BENE)
            case EnumProdottoActions. PRODOTTO_DELETE_GARANZIE :
                return Object.assign({}, state, { listaSegnelatori: action.dati })
    
                case EnumProdottoActions. PRODOTTO_DELETE_GARANZIE:
                return update(state, {
                    prodottoFirmaDigitale: { $set: action.result }
                })
        default:
            return state;
    }
}

export default prodotto;